import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GetDateWeeksString,GetChildrenInfoForList,GetChildrenStudyStatus, isObjEmpty,CheckIncludesIndex } from "../../../components/common/Common";
import closeIcon from "../../../img/icon/icon-list-arrow-01.svg";
import openIcon from "../../../img/icon/icon-list-arrow-02.svg";

const ClassStudyChildrens = ({varClassStudyIndex,varClassStudyInfo,varMainClassStudyType,varClassStudyType,setClassStudyType,
      varDeleteChildrenList,onShowStudyInfoHandler,varCanDeleteChildren,onSelectChildrenStudyHandler}) => {
  const navigate = useNavigate();
  //수업별 원생 배열
  const [varChildrenNormalList,setChildrenNormalList] = useState([]);
  const [varChildrenReinForceList,setChildrenReinForceList] = useState([]);
  /* const [varChildrenParticipateList,setChildrenParticipateList] = useState([]); */

  //수업차수 고유번호
  const [varClassStudyCode,setClassStudycode] = useState(0);

  //최초실행부
  useEffect(() => {
    const uniqueIndex = varClassStudyInfo.cs_idx;
    setClassStudycode(uniqueIndex);
    if(!isObjEmpty(varClassStudyInfo) && varClassStudyInfo.childrens.length > 0) {
      //해당차수의 원생배열
      const childrenList = varClassStudyInfo.childrens;
      //정규수업
      const normalList = childrenList.filter(el=>el.csc_mode === 0);
      setChildrenNormalList(normalList);
      //console.log(uniqueIndex,childrenList,normalList);
      //보강수업
      const reinForceList = childrenList.filter(el=>el.csc_mode === 1);
      setChildrenReinForceList(reinForceList);
      //참여수업
      /* const participateList = childrenList.filter(el=>el.csc_mode === 2);
      setChildrenParticipateList(participateList); */
    } else {
      setChildrenNormalList([]);
      setChildrenReinForceList([]);
      /* setChildrenParticipateList([]); */
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varClassStudyInfo.childrens]);

  //수업형태 변경시
  useEffect(() => {
    //수업차수가 같으면
    if(Math.round(varClassStudyType/10)===varClassStudyInfo.cs_index) {
      //해당차수 오픈
      //해당차수의 수업형태 선택표시
      const subSection = varClassStudyType%10;
      console.log(varClassStudyType,subSection);
    }
    const childrenBoxes = document.querySelectorAll('.study-children');
    childrenBoxes.forEach(el=>el.checked = false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varClassStudyType]);

  const onGotoChildrenPageHandle = (e,datas) => {
    navigate(`/Branch/ChildrenInformation/${datas.ch_idx}/${datas.csc_cl_idx}`);
  }

  return isObjEmpty(varClassStudyInfo)?null:(
    <>
      <div className="list-head" onClick={e=>onShowStudyInfoHandler(e,varClassStudyInfo.cs_idx)}>
        <img src={varClassStudyInfo.cs_idx===varClassStudyIndex?openIcon:closeIcon} alt=""/>
        <p>{varClassStudyInfo.cs_index}차 수업</p>
        <div>{GetDateWeeksString(varClassStudyInfo.cs_date)} {varClassStudyInfo.cs_hour}:{varClassStudyInfo.cs_minute}</div>
      </div>
      <div className="list-body">
        {/* 정규 수업 */}
        {varMainClassStudyType>0?null:
          <div className="bd-con">
            <div className="checkbox">
              <input type="radio" name="classType" id="tyNormal" value={0} checked={varClassStudyIndex===varClassStudyCode && varClassStudyType===0} onChange={()=>setClassStudyType(0)}/>
              <label htmlFor="tyNormal">정규 수업</label>
            </div>
            <ul>
              {varChildrenNormalList.map((normal,i1)=>(
                <li key={'normal_'+i1} className={GetChildrenStudyStatus(normal)===1?"":"state02"}>
                  <span onClick={e=>onGotoChildrenPageHandle(e,normal)}>{GetChildrenInfoForList(normal,1)}</span>
                  {!varCanDeleteChildren?null:<input type="checkbox" name="csc_idx" className="study-children" checked={CheckIncludesIndex(varDeleteChildrenList,normal.csc_idx)}  onChange={e=>onSelectChildrenStudyHandler(e,normal)}/>}
                </li>
              ))}
            </ul>
          </div>
        }
        {/* 보강 수업 */}
        {varMainClassStudyType===2?null:
          <div className="bd-con">
            <div className="checkbox">
              <input type="radio" name="classType" id="tyReinForce" value={1} checked={varClassStudyIndex===varClassStudyCode && varClassStudyType===1} onChange={()=>setClassStudyType(1)}/>
              <label htmlFor="tyReinForce">보강 수업</label>
            </div>
            <ul>
              {varChildrenReinForceList.map((reinforce,i2)=>(
                <li key={'reinforce_'+i2} className={GetChildrenStudyStatus(reinforce)===1?"":"state02"}>
                  <span onClick={e=>onGotoChildrenPageHandle(e,reinforce)}>{GetChildrenInfoForList(reinforce,1)}</span>
                  {!varCanDeleteChildren?null:<input type="checkbox" name="csc_idx" className="study-children" checked={CheckIncludesIndex(varDeleteChildrenList,reinforce.csc_idx)} onChange={e=>onSelectChildrenStudyHandler(e,reinforce)}/>}
                </li>
              ))}
            </ul>
          </div>
        }
        {/* 참여 수업 */}
        {/* {varMainClassStudyType===1?null:
          <div className="bd-con">
            <div className="checkbox">
                <input type="radio" name="classType" id="tyParticipate" value={2} checked={varClassStudyIndex===varClassStudyCode && varClassStudyType===2} onChange={()=>setClassStudyType(2)}/>
                <label htmlFor="tyParticipate">참여 수업</label>
              </div>
            <ul>
            {varChildrenParticipateList.length === 0 ?
              <li className="no-txt">⛔ 현재 참여 수업 인원이 존재하지 않습니다.</li>
            :
              varChildrenParticipateList.map((parti,i2)=>(
                <li key={'parti_'+i2} className={GetChildrenStudyStatus(parti)===1?"":"state02"}>
                  <span onClick={e=>onGotoChildrenPageHandle(e,parti)}>{GetChildrenInfoForList(parti,1)}</span>
                  {!varCanDeleteChildren?null:<input type="checkbox" name="csc_idx" className="study-children" checked={CheckIncludesIndex(varDeleteChildrenList,parti.csc_idx)} onChange={e=>onSelectChildrenStudyHandler(e,parti)}/>}
                </li>
              ))
            }
            </ul>
          </div>
        } */}
      </div>
    </>
  )
}
export default ClassStudyChildrens;